var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.108,
    height: 15.031,
    viewBox: "0 0 15.108 15.031",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6656",
    "data-name": "Group 6656",
    transform: "translate(5668 10181.021)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_626",
    "data-name": "Rectangle 626",
    width: 15,
    height: 15,
    transform: "translate(-5668 -10181)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_624",
    "data-name": "Rectangle 624",
    width: 15,
    height: 15,
    transform: "translate(-5667.892 -10181.021)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_1037",
    "data-name": "Path 1037",
    transform: "translate(-5653.926 -10181.013) rotate(90)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.268,0l-.6,4.732,4.357,1.84-4.357,1.84.6,4.732L7.512,10.254,3.756,13.146l.6-4.732L0,6.573l4.357-1.84L3.756,0,7.512,2.892Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9.972723007202148 2.259181022644043 L 7.511748313903809 4.154133796691895 L 5.050784111022949 2.259185791015625 L 5.444357872009277 5.358573436737061 L 2.56989574432373 6.572793483734131 L 5.444357872009277 7.787013530731201 L 5.050784111022949 10.88640117645264 L 7.511748313903809 8.991453170776367 L 9.972723007202148 10.88640594482422 L 9.579148292541504 7.787013530731201 L 12.45360565185547 6.572793483734131 L 9.579148292541504 5.358573436737061 L 9.972723007202148 2.259181022644043 M 3.755878448486328 3.814697265625e-06 L 7.511748313903809 2.892033576965332 L 11.26762866973877 3.814697265625e-06 L 10.66668891906738 4.732413291931152 L 15.02349853515625 6.572793483734131 L 10.66668891906738 8.413173675537109 L 11.26762866973877 13.145583152771 L 7.511748313903809 10.25355339050293 L 3.755878448486328 13.145583152771 L 4.356818199157715 8.413173675537109 L -1.9073486328125e-06 6.572793483734131 L 4.356818199157715 4.732413291931152 L 3.755878448486328 3.814697265625e-06 Z",
    stroke: "none",
    fill: "#14a4c2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.864e0b664f8ac935b408f0a32b607a2d.svg";
export { ForwardRef as ReactComponent };